// extracted by mini-css-extract-plugin
export default {"reg_wrap":"style_reg_wrap__Ge-ai","img":"style_img__HbpO2"};